import { createAction } from '@reduxjs/toolkit';

export const musicUpdateId = createAction('music/updateId');
export const musicUpdateUID = createAction('music/updateUid');
export const musicUpdateSID = createAction('music/updateSid');
export const musicUpdateIsAdded = createAction('music/updateIsAdded');
export const musicUpdateIsActive = createAction('music/updateIsActive');

export const musicStore = createAction('music/store');
export const musicClear = createAction('music/clear');

export const musicUpdateRequest = createAction('music/updateRequest');
export const musicUpdateError = createAction('music/updateError');
export const musicUpdateStore = createAction('music/updateStore');

export const musicUpdateItems = createAction('music/updateItems');

export const musicUpdateHeadingTitle = createAction('music/updateHeadingTitle');
export const musicUpdateHeadingDescription = createAction('music/updateHeadingDescription');
export const musicUpdateHeadingTextAlign = createAction('music/updateHeadingTextAlign');
export const musicUpdateHeadingImage = createAction('music/updateHeadingImage');
export const musicUpdateHeadingDivider = createAction('music/updateHeadingDivider');

export const musicUpdateSectionIsBackground = createAction('music/updateSectionIsBackground');
export const musicUpdateSectionTextColor = createAction('music/updateSectionTextColor');
export const musicUpdateSectionBackgroundColor = createAction('music/updateSectionBackgroundColor');
export const musicUpdateSectionOpacity = createAction('music/updateSectionOpacity');
export const musicUpdateSectionIsFullWidth = createAction('music/updateSectionIsFullWidth');
export const musicUpdateSectionShadow = createAction('music/updateSectionShadow');
export const musicUpdateSectionShadowColor = createAction('music/updateSectionShadowColor');
export const musicUpdateSectionPadding = createAction('music/updateSectionPadding');
export const musicUpdateSectionMargin = createAction('music/updateSectionMargin');
export const musicUpdateSectionBackgroundType = createAction('music/updateSectionBackgroundType');
export const musicUpdateSectionBackgroundImage = createAction('music/updateSectionBackgroundImage');
export const musicUpdateSectionGradientColor1 = createAction('music/updateSectionGradientColor1');
export const musicUpdateSectionGradientColor2 = createAction('music/updateSectionGradientColor2');
export const musicUpdateSectionGradientDirection = createAction('music/updateSectionGradientDirection');
export const musicUpdateSectionGradientOffset = createAction('music/updateSectionGradientOffset');
export const musicUpdateSectionBorder = createAction('music/updateSectionBorder');
export const musicUpdateSectionBorderColor = createAction('music/updateSectionBorderColor');
export const musicUpdateSectionShadowBorderColor = createAction('music/updateSectionShadowBorderColor');
export const musicUpdateSectionShape = createAction('music/updateSectionShape');

export const musicUpdateItemOpacity = createAction('music/updateItemOpacity');
export const musicUpdateItemShadow = createAction('music/updateItemShadow');
export const musicUpdateItemShadowColor = createAction('music/updateItemShadowColor');
export const musicUpdateItemBorder = createAction('music/updateItemBorder');
export const musicUpdateItemBorderColor = createAction('music/updateItemBorderColor');
export const musicUpdateItemShape = createAction('music/updateItemShape');
